(() => {
  if (customElements.get('promo-custom-decoration')) return;

  const SVG_NS = 'http://www.w3.org/2000/svg';

  /*
   * Dibujos internos. No se interpreta HTML ni JavaScript
   * procedente del campo JSON.
   */
  const drawings = {
    estrellas:
      '<path fill="currentColor" d="m50 3 14 29 32 5-23 23 5 32-28-15-28 15 5-32L4 37l32-5Z"/>',

    corazones:
      '<path fill="currentColor" d="M50 91 12 53C-12 29 22-8 50 22 78-8 112 29 88 53Z"/>',

    circulos:
      '<circle cx="50" cy="50" r="43" fill="currentColor"/>',

    confeti:
      '<rect x="34" y="10" width="32" height="80" rx="5" fill="currentColor"/>',

    copos:
      '<path d="M50 5v90M11 27l78 46M11 73l78-46M36 12l14 14 14-14M36 88l14-14 14 14" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round"/>',

    murcielago:
  '<path fill="currentColor" d="' +
  'M50 43 ' +
  'L45 33 L43 43 ' +
  'C33 34 19 32 4 27 ' +
  'C10 36 13 46 12 57 ' +
  'C21 50 29 52 34 61 ' +
  'C40 55 45 59 50 69 ' +
  'C55 59 60 55 66 61 ' +
  'C71 52 79 50 88 57 ' +
  'C87 46 90 36 96 27 ' +
  'C81 32 67 34 57 43 ' +
  'L55 33 L50 43Z"/>',
    lapida:
      '<path d="M19 91V38a31 31 0 0 1 62 0v53Z" fill="currentColor"/>' +
      '<path d="M35 39h30M50 24v31M32 71h36" stroke="#242034" stroke-width="5"/>' +
      '<path d="M9 92h82" stroke="#39333D" stroke-width="8" stroke-linecap="round"/>',

    dulce:
      '<path d="m28 37-23-9 6 23-6 22 23-10M72 37l23-9-6 23 6 22-23-10" fill="currentColor"/>' +
      '<rect x="23" y="28" width="54" height="48" rx="17" fill="currentColor"/>' +
      '<path d="m33 31 26 43M48 29l23 37" stroke="#FFF1D0" stroke-width="9"/>',

    castillo:
      '<path d="M8 95V42h22v53M70 95V42h22v53M30 95V57h40v38" fill="currentColor"/>' +
      '<path d="m5 42 14-29 14 29M67 42l14-29 14 29M28 57l22-38 22 38" fill="#24142F"/>' +
      '<path d="M43 95V77a7 7 0 0 1 14 0v18" fill="#100B1C"/>' +
      '<path d="M15 52h8v12h-8M77 52h8v12h-8M46 49h8v12h-8" fill="#FFD26A"/>' +
      '<path d="M19 13V3l14 5-14 5M81 13V3l14 5-14 5" fill="#C1434D"/>'
  };

  const styleId = 'mp-custom-scene-styles';

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;

    style.textContent = `
      .mp-scene-item {
        position:absolute;
        display:block;
        width:var(--scene-size);
        height:var(--scene-size);
        color:var(--scene-color);
        opacity:var(--scene-opacity);
        pointer-events:none;
      }

      .mp-scene-item svg,
      .mp-scene-item img {
        display:block;
        width:100%;
        height:100%;
        object-fit:contain;
      }

      .mp-scene-item--flotar {
        animation:mp-scene-float var(--scene-duration)
          ease-in-out var(--scene-delay) infinite alternate;
      }

      .mp-scene-item--girar {
        animation:mp-scene-spin var(--scene-duration)
          linear var(--scene-delay) infinite;
      }

      .mp-scene-item--volar {
        animation:mp-scene-fly var(--scene-duration)
          ease-in-out var(--scene-delay) infinite alternate;
      }

      .mp-scene-item--caer {
        animation:mp-scene-fall var(--scene-duration)
          linear var(--scene-delay) infinite;
      }

      .mp-scene-item--resplandor {
        animation:mp-scene-glow var(--scene-duration)
          ease-in-out var(--scene-delay) infinite alternate;
      }

      .mp-scene-wing {
        transform-box:view-box;
        transform-origin:50px 45px;
        animation:mp-scene-flap .55s ease-in-out infinite alternate;
      }

      .mp-scene-wing--right {
        animation-delay:-.2s;
      }

      @keyframes mp-scene-float {
        to { transform:translate(10px,-18px) rotate(7deg); }
      }

      @keyframes mp-scene-spin {
        to { transform:rotate(360deg); }
      }

      @keyframes mp-scene-fly {
        0% { transform:translate(-25px,0) rotate(-6deg); }
        50% { transform:translate(35px,-18px) rotate(4deg); }
        100% { transform:translate(95px,5px) rotate(-3deg); }
      }

      @keyframes mp-scene-fall {
        from { transform:translateY(-60px) rotate(0); }
        to {
          transform:translateY(var(--scene-height,500px)) rotate(180deg);
        }
      }

      @keyframes mp-scene-glow {
        to { filter:drop-shadow(0 0 12px currentColor); }
      }

      @keyframes mp-scene-flap {
        to { transform:scaleY(.55); }
      }

      @media(max-width:599px) {
        .mp-scene-item {
          width:var(--scene-mobile-size);
          height:var(--scene-mobile-size);
          left:var(--scene-mobile-x) !important;
          top:var(--scene-mobile-y) !important;
        }

        .mp-scene-item[data-hide-mobile] {
          display:none;
        }
      }

      @media(prefers-reduced-motion:reduce) {
        .mp-scene-item,
        .mp-scene-wing {
          animation:none;
        }
      }
    `;

    document.head.append(style);
  }

  function bounded(value, fallback, min, max) {
    return typeof value === 'number' && Number.isFinite(value)
      ? Math.min(max, Math.max(min, value))
      : fallback;
  }

  function validColor(value) {
    return typeof value === 'string' &&
      /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(value);
  }

  function imageUrl(value) {
    const url = new URL(value);

    if (
      url.protocol !== 'https:' ||
      url.hostname !== 'cdn.shopify.com' ||
      url.username ||
      url.password
    ) {
      throw new Error('Usa una imagen HTTPS de cdn.shopify.com.');
    }

    return url.href;
  }

  class PromoCustomDecoration extends HTMLElement {
    connectedCallback() {
      this.resizeObserver?.disconnect();
      this.replaceChildren();

      const warning = this.nextElementSibling;
      const hasWarning = warning?.classList.contains(
        'mp-custom-decor-warning'
      );

      if (hasWarning) warning.hidden = true;
      if (this.dataset.enabled !== 'true') return;

      const raw = (this.dataset.config || '').trim();
      if (!raw) return;

      try {
        if (raw.length > 18000) {
          throw new Error('Configuración demasiado larga.');
        }

        const config = JSON.parse(raw);

        if (
          !config ||
          typeof config !== 'object' ||
          Array.isArray(config)
        ) {
          throw new Error('El JSON debe ser un objeto.');
        }

        let elements = [];

        /*
         * Compatibilidad con el formato anterior.
         */
        if (config.particulas) {
          const p = config.particulas;
          const decoration = config.decoracion || {};

          elements.push({
            tipo: p.tipo || 'estrellas',
            cantidad: p.cantidad ?? 18,
            colores: p.colores || ['#FFFFFF'],
            tamano_min: p.tamano_min ?? 8,
            tamano_max: p.tamano_max ?? 22,
            opacidad: p.opacidad ?? 0.45,
            animacion: p.movimiento || 'flotar',
            velocidad: p.velocidad || 'lenta',
            posicion: decoration.posicion || 'todo'
          });

          if (decoration.confeti === true) {
            elements.push({
              tipo: 'confeti',
              cantidad: 8,
              colores: p.colores || ['#FFFFFF'],
              tamano: 12,
              animacion: 'caer'
            });
          }
        }

        if (config.elementos !== undefined) {
          if (!Array.isArray(config.elementos)) {
            throw new Error('elementos debe ser una lista.');
          }

          elements = elements.concat(config.elementos);
        }

        if (!elements.length || elements.length > 20) {
          throw new Error('Añade entre 1 y 20 grupos de elementos.');
        }

        const fragment = document.createDocumentFragment();
        let total = 0;

        for (const element of elements) {
          if (!element || typeof element !== 'object') {
            throw new Error('Elemento inválido.');
          }

          const type = element.tipo;
          const isImage = type === 'imagen';

          if (
            !isImage &&
            !Object.prototype.hasOwnProperty.call(drawings, type)
          ) {
            throw new Error('Tipo de elemento no disponible.');
          }

          const source = isImage ? imageUrl(element.url) : null;
          const colors = element.colores || [element.color || '#FFFFFF'];

          if (
            !Array.isArray(colors) ||
            !colors.length ||
            colors.length > 12 ||
            !colors.every(validColor)
          ) {
            throw new Error('Usa colores HEX válidos.');
          }

          const animation =
            element.animacion || element.movimiento || 'ninguno';

          if (![
            'ninguno', 'ninguna', 'flotar',
            'volar', 'girar', 'caer', 'resplandor'
          ].includes(animation)) {
            throw new Error('Animación no disponible.');
          }

          const speeds = { lenta: 14, media: 9, rapida: 5 };
          const speed = element.velocidad || 'lenta';

          if (!Object.prototype.hasOwnProperty.call(speeds, speed)) {
            throw new Error('Velocidad no disponible.');
          }

          const count = Math.round(
            bounded(element.cantidad, 1, 0, 40)
          );

          const position = element.posicion || 'todo';

          if (![
            'todo', 'bordes', 'arriba', 'abajo',
            'derecha', 'izquierda'
          ].includes(position)) {
            throw new Error('Posición no disponible.');
          }

          for (let index = 0; index < count && total < 48; index++) {
            total++;

            const item = document.createElement('span');
            item.className = 'mp-scene-item';

            if (!['ninguno', 'ninguna'].includes(animation)) {
              item.classList.add(`mp-scene-item--${animation}`);
            }

            const minSize = bounded(element.tamano_min, 12, 3, 320);
            const maxSize = Math.max(
              minSize,
              bounded(element.tamano_max, minSize, 3, 320)
            );

            const size = bounded(
              element.tamano,
              minSize + Math.random() * (maxSize - minSize),
              3,
              320
            );

            let x = Math.random() * 88;
            let y = Math.random() * 80;

            if (position === 'arriba') y = 3;
            if (position === 'abajo') y = 88;
            if (position === 'derecha') x = 86;
            if (position === 'izquierda') x = 2;
            if (position === 'bordes') y = index % 2 ? 88 : 3;
            if (animation === 'caer') y = 0;

            x = bounded(element.x, x, 0, 100);
            y = bounded(element.y, y, 0, 100);

            item.style.left = `${x}%`;
            item.style.top = `${y}%`;

            item.style.setProperty('--scene-size', `${size}px`);
            item.style.setProperty(
              '--scene-mobile-size',
              `${bounded(element.tamano_movil, size * 0.7, 3, 220)}px`
            );
            item.style.setProperty(
              '--scene-mobile-x',
              `${bounded(element.x_movil, x, 0, 100)}%`
            );
            item.style.setProperty(
              '--scene-mobile-y',
              `${bounded(element.y_movil, y, 0, 100)}%`
            );
            item.style.setProperty(
              '--scene-color',
              colors[index % colors.length]
            );
            item.style.setProperty(
              '--scene-opacity',
              bounded(element.opacidad, 0.65, 0.1, 1)
            );
            item.style.setProperty(
              '--scene-duration',
              `${speeds[speed] + Math.random() * 3}s`
            );
            item.style.setProperty(
              '--scene-delay',
              `${-Math.random() * speeds[speed]}s`
            );

            if (
              element.ocultar_movil === true ||
              (count > 6 && index % 2 === 1)
            ) {
              item.setAttribute('data-hide-mobile', '');
            }

            if (isImage) {
              const image = document.createElement('img');
              image.src = source;
              image.alt = '';
              image.loading = 'lazy';
              image.draggable = false;
              item.append(image);
            } else {
              const svg = document.createElementNS(SVG_NS, 'svg');
              svg.setAttribute('viewBox', '0 0 100 100');
              svg.setAttribute('focusable', 'false');

              // Solo utiliza dibujos fijos del código.
              svg.innerHTML = drawings[type];
              item.append(svg);
            }

            fragment.append(item);
          }
        }

        this.append(fragment);

        const updateHeight = () => {
          this.style.setProperty(
            '--scene-height',
            `${this.clientHeight + 100}px`
          );
        };

        updateHeight();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(updateHeight);
          this.resizeObserver.observe(this);
        }
      } catch (error) {
        this.replaceChildren();

        if (hasWarning) {
          warning.textContent =
            'Decoración personalizada: ' +
            (error instanceof Error ? error.message : 'Revisa el JSON.') +
            ' Se mantiene el diseño base.';
          warning.hidden = false;
        }
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define(
    'promo-custom-decoration',
    PromoCustomDecoration
  );
})();
